import { FormLabel, Typography, useTheme } from '@mui/material';
import { COLOR_CARNATION, FONT_SIZE_10_PX, FONT_WEIGHT_SEMI_BOLD } from '../../popTheme';

export const SettingsFormLabel = ({ subtitle, inputId = '', isRequired, color, error }) => {
  const theme = useTheme();
  return (
    <FormLabel
      error={error}
      required={isRequired}
      component={Typography}
      variant="subtitle1"
      htmlFor={inputId}
      sx={{
        alignSelf: 'baseline',
        color: !!color ? color : 'text.tertiary',
        ml: '0.75rem',
        mb: '0.5rem',
        mt: '0.5rem',
        fontWeight: FONT_WEIGHT_SEMI_BOLD,
        [theme.breakpoints.only('xs')]: {
          fontSize: FONT_SIZE_10_PX,
        },

        '.MuiFormLabel-asterisk': {
          color: COLOR_CARNATION,
        },
      }}
    >
      {subtitle}
    </FormLabel>
  );
};
